module.exports = __webpack_public_path__ + "img/phone1.83056f24.png";